(() => {
  'use strict';

  const fillCollectionHero = () => {
    document.querySelectorAll('.bw-collection-hero__image').forEach((hero) => {
      if (hero.querySelector('img')) return;

      const source = document.querySelector('.bw-products--collection .bw-product__card-image');
      if (!source || !source.src) return;

      const image = document.createElement('img');
      image.src = source.currentSrc || source.src;
      if (source.srcset) image.srcset = source.srcset;
      if (source.sizes) image.sizes = source.sizes;
      image.loading = 'eager';
      image.fetchPriority = 'high';
      image.alt = `${document.querySelector('.bw-collection-hero h1')?.textContent?.trim() || 'Bathwise'} collection`;
      image.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;';
      hero.appendChild(image);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillCollectionHero, { once: true });
  } else {
    fillCollectionHero();
  }
})();
